.containerPadding {
    padding: 20px;
}